import React from "react";
const DropdownOption = (props: any) => {
    return (
        <tr className={"selection--option"} onClick={props.clickHandler}>
            <td className={"custom-radio"} style={{ textAlign: "center" }}>
                <div className={"form-check"}>
                    <label className={"form-check-label"}>
                        <input type="radio" name={props.type + "-input"} checked={props.checked}
                            className={"form-check-input tmg--radio"} value={props.id} onChange={() => { }} />&zwnj;
                    </label>
                </div>
            </td>
            {/* {props.code != '' &&
                <td className={"code"} style={{ paddingTop: props.code.length <= 10 ? 5 : 0 }}>{props.code}</td>
            } */}
            <td className={"name"}>{props.name}</td>
        </tr>
    );
}

export default DropdownOption